import Icon1 from "@assets/icons/Icon";
import { ActionsMenuButton } from "@components/ui/buttons/ActionsMenuButton";
import Button from "@components/ui/buttons/Button";
import MenuButton from "@components/ui/buttons/MenuButton";
import MenuInception from "@components/ui/buttons/MenuInception";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";
import Container from "@components/ui/Container";
import DropDown from "@components/ui/dropdown/DropDown";
import DropDownMultiple from "@components/ui/dropdown/DropDownMultiple";
import DropDownSearch from "@components/ui/dropdown/DropDownSearch";
import SearchAlgolia from "@components/ui/search/SearchAlgolia";
import { handleQuerySearch } from "@components/ui/search/searchHelpers";
import CardSelection from "@components/ui/selection/CardSelection";
import CheckBoxInput from "@components/ui/selection/CheckBoxInput";
import { ChunkyTabs } from "@components/ui/selection/ChunkyTabs";
import DatePicker from "@components/ui/selection/DatePicker";
import { Switch } from "@components/ui/selection/Switch";
import { SwitchBrick } from "@components/ui/selection/SwitchBrick";
import { Tabs } from "@components/ui/selection/Tabs";
import TimePicker from "@components/ui/selection/TimePicker";
import { StatusBlock } from "@components/ui/blocks/Status";
import AreaTextField from "@components/ui/textfields/AreaTextField";
import TextField from "@components/ui/textfields/TextField";
import { Text1, Text2, Text3 } from "@components/ui/texts/Texts";
import SideMenuButton from "@navigation/SideMenuButton";
import { raiseError } from "context/error.service";
import { useEffect, useState } from "react";
import { colors } from "sexy";
import { MemberAssignmentBlock } from "@components/ui/blocks/MemberAssignmentBlock";
import { CopiableInfosSection } from "@components/ui/blocks/CopiableInfosSection";
import {
  history_data,
  options,
  sample_folders,
  sampleProjects,
} from "./sampleData";
import DataGrid from "@components/ui/tables/DataGrid";
import { transformProjectsToTable } from "@components/ui/tables/transformToTables";
import { useDataStore } from "@store/user_org";
import { useConfigStore } from "@store/persist";
import {
  getHistoryDateFromFlutter,
  getLocalFromFlutter,
} from "@services/timeHelpers";
import { VerticalTimeline } from "@components/ui/blocks/VericalTimeline";
import { DocumentSection } from "@components/ui/blocks/DocumentSection";
import { DropFileModal } from "@components/modals/DropFileModal";
import { CreateProjectModal } from "@components/modals/CreateProjectModal";
import { GenerateFileModal } from "@components/modals/GenerateFileModal";
import { EmailModal } from "@components/modals/EmailModal";
import {
  PrepareSignature,
  FillSignature,
  FieldData,
} from "@components/modals/signature";
import { EditablePdfGenerator } from "@components/modals/pdf/EditablePdfGenerator";
import { signaturesApi } from "@services/api/signatures";
import { pdfApi } from "@services/api/pdf";
import { showNotification } from "context/notification.service";
import { PDFViewerModal } from "@components/modals/PDFViewerModal";
import { StepsList } from "@components/ui/blocks/StepsList";
import { useProjectStore } from "@store/projectStore";
import { ActionsMenuButtonProject } from "@components/ui/buttons/ActionsMenuButtonProject";

export default function ComponentsScreen() {
  const [option, setOption] = useState<string | number>("");
  const [algoliaValue, setAlgoliaValue] = useState<string>("");
  const [algoliaResults, setAlgoliaResults] = useState<any[]>([]);
  const [selectedValues, setSelectedValues] = useState<(string | number)[]>([]);
  const [seconds, setSeconds] = useState<number>(0);
  const [timeValue, setTimeValue] = useState<string>("12:00");
  const [activated, setActivated] = useState<boolean>(false);
  const [description, setDescription] = useState<string>("");
  const [activeTab, setActiveTab] = useState<string>("fil");
  const { activeProject, setActiveProject } = useProjectStore();
  const [selectedEnvironment, setSelectedEnvironment] = useState<
    string | number
  >("kubernetes");
  const orgData = useDataStore((state) => state.orgData);
  const prefix = useConfigStore((state) => state.prefix);
  const [table, setTable] = useState<any>(null);
  const [dropFileModalOpen, setDropFileModalOpen] = useState<boolean>(false);
  const [createFolderOpen, setCreateFolderOpen] = useState<boolean>(false);
  const [generateReportOpen, setGenerateReportOpen] = useState<boolean>(false);
  const [emailOpen, setEmailOpen] = useState<boolean>(false);
  // Signature flow states
  const [signatureStep, setSignatureStep] = useState<
    "select" | "prepare" | "fill" | null
  >(null);
  const [pdfFile, setPdfFile] = useState<File | null>(null);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState<string>("");
  const [preparedPdfUrl, setPreparedPdfUrl] = useState<string>("");
  const [viergePdfUrl, setViergePdfUrl] = useState<string>("");
  const [preparedFields, setPreparedFields] = useState<FieldData[]>([]);
  const [signedPdfUrl, setSignedPdfUrl] = useState<string>("");
  const [pdfEditorOpen, setPdfEditorOpen] = useState<boolean>(false);
  const [generatedPdfUrl, setGeneratedPdfUrl] = useState<string>("");

  const handleGeneratePDF = async () => {
    try {
      showNotification({
        type: "default",
        message: "Génération du PDF...",
      });

      const pdfBlob = await pdfApi.generate({
        title: "Facture",
        document_number: "INV-2024-001",
        date: new Date().toISOString().split("T")[0],
        client: {
          name: "Jean Dupont",
          email: "jean.dupont@example.com",
          phone: "+33 6 12 34 56 78",
          address: "123 Rue de la Paix, 75001 Paris",
        },
        items: [
          {
            description: "Consultation technique",
            quantity: 2,
            unit_price: 150.0,
          },
          {
            description: "Développement personnalisé",
            quantity: 5,
            unit_price: 200.0,
          },
        ],
        notes: "Paiement dans les 30 jours. Merci pour votre confiance.",
      });

      const url = URL.createObjectURL(pdfBlob);
      setGeneratedPdfUrl(url);

      showNotification({
        type: "success",
        message: "PDF généré avec succès",
      });
    } catch (error) {
      console.error("Failed to generate PDF:", error);
      showNotification({
        type: "error",
        message: "Impossible de générer le PDF",
      });
    }
  };

  const handleFetchData = async () => {
    const table = transformProjectsToTable(
      sampleProjects,
      "completed",
      orgData,
      "",
    );
    setTable(table);
  };

  useEffect(() => {
    handleFetchData();
  }, [orgData]);
  return (
    <div className="flex flex-col  overflow-auto max-h-screen  ">
      <div className="flex flex-col h-fit pb-96 mt-10 ml-10">
        <div className="flex flex-col w-400 gap-4  ">
          <div className="flex flex-col   ">
            <Text1>Projets</Text1>
            <Text2>Retrouvez tous vos projets ici.</Text2>
            <Text3>
              Les projets sont organisés par status et priorité. Vous pouvez
              utiliser les filtres pour affiner votre recherche.
            </Text3>
          </div>
          <StatusBlock type="step" label="Pose de la charpente"></StatusBlock>
          <StatusBlock
            type="success"
            label="Accès chantier terminé"
          ></StatusBlock>
          <StatusBlock type="ai" label="Généré par IA"></StatusBlock>
          <StatusBlock type="error" label="Erreur de génération"></StatusBlock>
          <StatusBlock type="info" label="L'email sera envoyé"></StatusBlock>
          <StatusBlock type="default" label="Simple"></StatusBlock>
          <MemberAssignmentBlock></MemberAssignmentBlock>
          <CopiableInfosSection></CopiableInfosSection>
          <StepsList
            project={sampleProjects[0]}
            setProject={(pro) => {}}
            label="Etapes"
          ></StepsList>

          <TextField
            label="Ville"
            placeholder="Rennes"
            onChange={(value) => {
              console.log("Input changed:", value);
            }}
          />
          <Switch
            checked={activated}
            onChange={(checked) => setActivated(checked)}
          ></Switch>
          <Tabs
            tabs={[
              {
                value: "fil",
                label: "Fil du projet",
              },
              {
                value: "steps",
                label: "Étapes",
              },
              {
                value: "photos",
                label: "Photos",
              },
              {
                value: "documents",
                label: "Documents",
              },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></Tabs>
          <ChunkyTabs
            tabs={[
              {
                value: "fil",
                label: "Fil du projet",
              },
              {
                value: "steps",
                label: "Étapes",
              },
              {
                value: "photos",
                label: "Photos",
              },
              {
                value: "documents",
                label: "Documents",
              },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          ></ChunkyTabs>
          <AreaTextField
            label="Description"
            placeholder="Decrivez votre projet ici..."
            rows={3}
            value={description}
            setValue={setDescription}
          />
          <SwitchBrick
            checked={activated}
            onChange={(checked) => setActivated(checked)}
            title="Activer les notifications"
            description="Recevez des notifications pour chaque mise à jour importante."
          ></SwitchBrick>
          <DropDown
            options={options}
            label="Client"
            onSelect={(value) => {
              console.log("Selected item:", value);
              setOption(value);
            }}
            value={option}
          ></DropDown>
          <DropDownSearch
            options={options}
            label="Prestation"
            onSelect={(value) => {
              console.log("Selected item:", value);
              setOption(value);
            }}
            value={option}
          ></DropDownSearch>
          <DropDownMultiple
            options={options}
            label="Techniciens"
            onSelect={(value) => {
              console.log("Selected items:", value);
              setSelectedValues(value);
            }}
            value={selectedValues}
          ></DropDownMultiple>
          <SearchAlgolia
            setValue={(value) =>
              handleQuerySearch(
                value,
                setAlgoliaResults,
                setAlgoliaValue,
                "folder",
                [
                  {
                    field: "master_id",
                    operator: "==",
                    value: "wmLGIwRMtQD2LLc6nXQf",
                  },
                ],
                null,
              )
            }
            onAction={() => {}}
            options={algoliaResults.map((result) => ({
              label: result.nom,
              value: result.objectID,
              extra_label: result.marque,
              extra_label_2: result.ville,
            }))}
            value={algoliaValue}
          ></SearchAlgolia>
          <Button
            label="Se connecter"
            onClick={() =>
              raiseError({
                type: "Authentication Error",
                reason: "Erreur d'authentification",
                solutions: ["Veuillez réessayer"],
              })
            }
          ></Button>
          <Button
            variant="medium"
            label="Créer un projet"
            onClick={() =>
              raiseError({
                type: "Authentication Error",
                reason: "Erreur d'authentification",
                solutions: ["Veuillez réessayer"],
              })
            }
          ></Button>
          <Button
            variant="small"
            label="Confirmer"
            onClick={() =>
              raiseError({
                type: "Authentication Error",
                reason: "Erreur d'authentification",
                solutions: ["Veuillez réessayer", "Contactez le support"],
              })
            }
          ></Button>
          <SecondaryButton variant="large" onClick={() => {}}>
            Fermer
          </SecondaryButton>
          <SecondaryButton variant="small" onClick={() => {}}>
            Annuler
          </SecondaryButton>
          <ActionsMenuButtonProject
            project={activeProject!}
            setProject={setActiveProject}
          ></ActionsMenuButtonProject>

          <CheckBoxInput
            label="Accepter les termes et conditions"
            checked={true}
            onChange={(checked) => {
              console.log("Checkbox changed:", checked);
            }}
          />
          <CardSelection
            label=""
            subtitle=""
            options={[
              {
                value: "kubernetes",
                title: "Kubernetes",
                description:
                  "Utiliser un cluster Kubernetes pour déployer vos applications.",
              },
              {
                value: "vm",
                title: "Machine Virtuelle",
                description:
                  "Utiliser une machine virtuelle pour plus de contrôle.",
                comingSoon: false,
              },
            ]}
            value={selectedEnvironment}
            onChange={setSelectedEnvironment}
          />
          <DatePicker
            label="Sélectionnez une date"
            seconds={seconds}
            onChange={(s) => setSeconds(s)}
          ></DatePicker>
          <TimePicker
            label="Sélectionnez une horaire"
            value={timeValue}
            onChange={(value) => setTimeValue(value)}
          ></TimePicker>
        </div>
        <div className="flex flex-col h-fit w-1k mt-4 gap-4">
          <div className="h-300 ">
            {table && (
              <DataGrid
                selectable={true}
                table={table}
                hide_lines={true}
              ></DataGrid>
            )}
          </div>
          <div className="h-300 ">
            <VerticalTimeline></VerticalTimeline>
          </div>
          <DocumentSection folders={sample_folders}></DocumentSection>
          <Button
            variant="small"
            label="Ajouter un fichier"
            onClick={() => setDropFileModalOpen(true)}
          ></Button>
          {dropFileModalOpen && (
            <DropFileModal
              onClose={() => setDropFileModalOpen(false)}
            ></DropFileModal>
          )}
          <Button
            variant="small"
            label="Créer un dossier"
            onClick={() => setCreateFolderOpen(true)}
          ></Button>
          {createFolderOpen && (
            <CreateProjectModal
              onClose={() => setCreateFolderOpen(false)}
            ></CreateProjectModal>
          )}
          <Button
            variant="small"
            label="Générer un compte rendu"
            onClick={() => setGenerateReportOpen(true)}
          ></Button>
          {generateReportOpen && (
            <GenerateFileModal
              onClose={() => setGenerateReportOpen(false)}
            ></GenerateFileModal>
          )}
          <Button
            variant="small"
            label="Envoyer un email"
            onClick={() => setEmailOpen(true)}
          ></Button>
          {emailOpen && (
            <EmailModal onClose={() => setEmailOpen(false)}></EmailModal>
          )}
          <Button
            variant="small"
            label="Préparer la signature"
            onClick={() => setSignatureStep("select")}
          ></Button>
          <Button
            variant="small"
            label="Générer un PDF"
            onClick={handleGeneratePDF}
          ></Button>

          {/* Step 1: Select PDF */}
          {signatureStep === "select" && (
            <DropFileModal
              title="Sélectionner un PDF à signer"
              saveButtonLabel="Continuer"
              showRepertorySelector={false}
              showElectronicSignature={false}
              showInternalDocument={false}
              onClose={() => setSignatureStep(null)}
              onSave={(data) => {
                const file = data.files[0];
                if (file && file.type === "application/pdf") {
                  setPdfFile(file);
                  setSelectedPdfUrl(URL.createObjectURL(file));
                  setSignatureStep("prepare");
                }
              }}
            />
          )}

          {/* Step 2: Prepare signature fields */}
          {signatureStep === "prepare" && selectedPdfUrl && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-lg shadow-2xl w-11/12 h-5/6 overflow-hidden">
                <PrepareSignature
                  pdfUrl={selectedPdfUrl}
                  readyButtonLabel="Prêt pour signature"
                  onClose={() => {
                    setSignatureStep(null);
                    setPdfFile(null);
                    setSelectedPdfUrl("");
                  }}
                  onReadyForSignature={async (fields, dimensions) => {
                    try {
                      if (!pdfFile) return;

                      const transformedFields = fields.map((field) => ({
                        type: field.type as
                          | "Signature"
                          | "Text"
                          | "Date"
                          | "Tampon",
                        x: field.left,
                        y: field.top,
                        width: field.width,
                        height: field.height,
                        page: field.page,
                        content: field.content,
                        label: field.name,
                      }));

                      showNotification({
                        type: "default",
                        message: "Préparation du document...",
                      });

                      const prepareResponse = await signaturesApi.prepare({
                        pdf_file: pdfFile,
                        fields: transformedFields,
                        target_width: dimensions.width,
                        target_height: dimensions.height,
                      });

                      setPreparedPdfUrl(prepareResponse.pdf_url);
                      setViergePdfUrl(prepareResponse.vierge_pdf_url || "");
                      setPreparedFields(fields);
                      setSignatureStep("fill");

                      showNotification({
                        type: "success",
                        message: "Document préparé. Remplissez les champs.",
                      });
                    } catch (error) {
                      console.error("Failed to prepare document:", error);
                      showNotification({
                        type: "error",
                        message: "Impossible de préparer le document",
                      });
                    }
                  }}
                />
              </div>
            </div>
          )}

          {/* Step 3: Fill and sign */}
          {signatureStep === "fill" && preparedPdfUrl && (
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-lg shadow-2xl w-11/12 h-5/6 overflow-hidden">
                <FillSignature
                  pdfUrl={preparedPdfUrl}
                  initialFields={preparedFields}
                  onClose={() => {
                    setSignatureStep(null);
                    setPdfFile(null);
                    setSelectedPdfUrl("");
                    setPreparedPdfUrl("");
                    setViergePdfUrl("");
                    setPreparedFields([]);
                  }}
                  onSign={async (fields, dimensions) => {
                    try {
                      const transformedFields = fields.map((field) => ({
                        type: field.type as
                          | "Signature"
                          | "Text"
                          | "Date"
                          | "Tampon",
                        x: field.left,
                        y: field.top,
                        width: field.width,
                        height: field.height,
                        page: field.page,
                        content: field.content,
                        label: field.name,
                      }));

                      showNotification({
                        type: "default",
                        message: "Signature du document...",
                      });

                      const signResponse = await signaturesApi.sign({
                        pdf_url: viergePdfUrl || preparedPdfUrl,
                        fields: transformedFields,
                        target_width: dimensions.width,
                        target_height: dimensions.height,
                      });

                      setSignedPdfUrl(signResponse.pdf_url);
                      setSignatureStep(null);
                      setPreparedPdfUrl("");
                      setViergePdfUrl("");
                      setPreparedFields([]);

                      showNotification({
                        type: "success",
                        message: "Document signé avec succès",
                      });
                    } catch (error) {
                      console.error("Failed to sign document:", error);
                      showNotification({
                        type: "error",
                        message: "Impossible de signer le document",
                      });
                    }
                  }}
                />
              </div>
            </div>
          )}
          <Button
            variant="small"
            label="Générer PDF éditable"
            onClick={() => setPdfEditorOpen(true)}
          ></Button>
          {pdfEditorOpen && (
            <EditablePdfGenerator onClose={() => setPdfEditorOpen(false)} />
          )}
          {signedPdfUrl && (
            <PDFViewerModal
              pdfUrl={signedPdfUrl}
              title="Document signé"
              onClose={() => setSignedPdfUrl("")}
            />
          )}
          {generatedPdfUrl && (
            <PDFViewerModal
              pdfUrl={generatedPdfUrl}
              title="PDF Généré"
              onClose={() => {
                URL.revokeObjectURL(generatedPdfUrl);
                setGeneratedPdfUrl("");
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
